import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';

import 'vue-swatches/dist/vue-swatches.css'

import '@/extensions/mainExtension'
import '@/extensions/TouchSelectionExtension'
import '@/extensions/MeasurementExtension'
import '@/extensions/Cropping2DExtension'
import '@/extensions/Cropping3DExtension'
import '@/extensions/ScaffoldBoxExtension'
import '@/extensions/CustomContextMenuExtension'
import '@/extensions/mapping2d_3dExtension'
import '@/extensions/CameraTweenTool'
import '@/extensions/Plan2DExtension'
import '@/extensions/WalkingPathExt'
import '@/extensions/labels3dExt'

import '@/fonts/Artifakt_Regular'
import '@/fonts/Artefact_Bold'

import { showVirtualKeyboardOnFocus } from './scripts/js/forgeService';

Vue.config.productionTip = false;

Vue.directive('virtual-keyboard', {
  bind: function (el) {
      (typeof el !== 'undefined' && typeof el.addEventListener === 'function') && el.addEventListener("focus", showVirtualKeyboardOnFocus);
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')